export const createTicketTemplate = (ticketId: string, numberTicket: string) => {
	return `
				<h2><strong>A Taugor recebeu sua solicitação</strong><br /></h2>
				Número do seu ticket: <strong>#${numberTicket}</strong><br /><br />

				Recebemos sua solicitação com sucesso!<br />
Para acompanhar o andamento ou responder a este chamado, acesse o link da central Inbox:<br /><br />

👉 <a href="https://inbox.taugor.app/tickets/${ticketId}" target="_blank">Acesse seu ticket</a><br /><br />

⚠️ <strong>Importante:</strong> Não responda este e-mail. As mensagens por e-mail não são monitoradas.<br />
Se precisar complementar alguma informação, entre na central Inbox e responda diretamente por lá.

                <br /><br />
                Atenciosamente,<br />
                Suporte Taugor<br />
    `;
};
